import React from 'react';

const STATUS_MAP = {
  payment_pending:   { label: 'Menunggu Pembayaran', cls: 's-payment_pending' },
  payment_confirmed: { label: 'Pembayaran Dikonfirmasi', cls: 's-payment_confirmed' },
  writing:           { label: 'Sedang Ditulis Editor', cls: 's-writing' },
  review_producer:   { label: 'Review Producer', cls: 's-review_producer' },
  revision_editor:   { label: 'Revisi dari Producer', cls: 's-revision_editor' },
  review_reader:     { label: 'Menunggu Persetujuan Pengaju', cls: 's-review_reader' },
  revision_reader:   { label: 'Revisi dari Pengaju', cls: 's-revision_reader' },
  approved:          { label: 'Disetujui, Siap Publish', cls: 's-approved' },
  published:           { label: 'Terpublikasi',  cls: 's-published' },
  rejected:            { label: 'Ditolak',        cls: 's-rejected' },
  deletion_requested:  { label: 'Ajukan Hapus',  cls: 's-rejected' },
};

export default function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || { label: status, cls: '' };
  return <span className={"status-badge " + s.cls}>{s.label}</span>;
}

export { STATUS_MAP };
